import { DeviceInfoModel } from './DeviceInfoModel';

export class UserRegistrationModel extends DeviceInfoModel
{
    Username : string;
    Password : string;
    DeviceId : string;
}